const SubscriptionIcon = ({color}: {color?: string}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='18' viewBox='0 0 22 18' fill='none'>
      <path
        d='M4.12921 16.749H17.8711C18.0474 16.7491 18.2181 16.687 18.3532 16.5736C18.4883 16.4603 18.5792 16.303 18.6098 16.1293L20.738 6.37934C20.7647 6.21889 20.7385 6.0541 20.6634 5.90982C20.5883 5.76554 20.4684 5.64959 20.3216 5.57944C20.1749 5.50929 20.0093 5.48875 19.8498 5.52092C19.6904 5.55308 19.5457 5.63621 19.4376 5.75777L15.5001 9.99902L11.6808 1.43496C11.6207 1.30507 11.5246 1.1951 11.404 1.11803C11.2834 1.04095 11.1433 1 11.0001 1C10.857 1 10.7169 1.04095 10.5963 1.11803C10.4757 1.1951 10.3796 1.30507 10.3195 1.43496L6.50015 9.99902L2.56265 5.75777C2.4548 5.63444 2.30954 5.54981 2.14906 5.51682C1.98859 5.48383 1.82172 5.5043 1.67397 5.57509C1.52623 5.64588 1.40572 5.76311 1.33088 5.90885C1.25604 6.05459 1.23097 6.22082 1.25952 6.38215L3.38765 16.1321C3.41896 16.3058 3.51047 16.4628 3.6461 16.5756C3.78173 16.6884 3.95279 16.7498 4.12921 16.749Z'
        stroke={color || '#735BF2'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SubscriptionIcon
